// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3C5tk","container":"style_container__2YiRX","titlePart":"style_titlePart__P4QIi","propsContainer":"style_propsContainer__1Pydc"};